import React from "react";
import { Button } from "reactstrap";

const CustomButton = ({ label, width, style, ...rest }) => {
  return (
    <Button
      color="primary"
      style={{
        margin: "30px 0px",
        color: "#000000",
        border: 0,
        width: width || "auto",
        ...style
      }}
      {...rest}>
      {label}
    </Button>
  );
};

export default CustomButton;
